import axios from 'axios';
import { MDBFileUpload } from "mdb-react-file-upload";
import {
  MDBAlert,
  MDBBtn,
  MDBCard, MDBCardBody,
  MDBCardHeader,
  MDBInput, MDBTextArea
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from "react";
import Dropdown from './../reusables/Dropdown';
import { NavbarContext } from '../context/NavProvider';
import { MiscContext } from '../context/MiscProvider';
import { CategoryContext } from '../context/CategoryContext';
import { DomainContext } from '../context/DomainProvider';
const CategoryForm = ({   setShowCategoryModal, showCategoryModal, categoryToUpdate, setActiveTab }) => {

const {setCategoryData,categoryData} = useContext(CategoryContext);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [isFormValid, setIsFormValid] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertColor, setAlertColor] = useState('');
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);

const firmFromLocalStorage = localStorage.getItem('FIRM');
  const { setCategoryImages,setIsCategoryFormSubmitted,setSelectCategories} = useContext(CategoryContext);
  const {selectDomains} = useContext(DomainContext);


  const firm = selectDomains?.find(dom => dom.value === firmFromLocalStorage)?.text;
  const [localCategories, setLocalCategories] = useState([{ name: '', domainIds: [], description: '', firm: firm, file: {} }]);
  useEffect(() => {
    if (categoryData) {
      setName('');
      setDescription('');
      setFile(null);
    }
  }, [categoryData]);
  useEffect(() => {

    if (categoryToUpdate) {
      setLocalCategories([categoryToUpdate]);
    } else {
      setLocalCategories([{
        name: '',
        firm: localStorage.getItem('FIRM'),
        domainIds: [],
        description: '',
        file: {}
      }]);
    }
  }, [categoryToUpdate]);
  

  const addCategory = () => {
    setLocalCategories(prev => [...prev, {
      name: '',
      firmId: firmFromLocalStorage,
      firm: firm,
      domainIds: [],
      description: "",
      file: {}
    }]);
  };

  // This function gets called after you've successfully updated a category.
const onCategoryUpdate = (updatedCategory) => {
  // Assume updatedCategory has a `name` field and an `imageURL` field
  setCategoryImages(prevCategoryImages => {
    return {
      ...prevCategoryImages,
      [updatedCategory.name]: updatedCategory.imageURL
    };
  });
};


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    localCategories[0].firm = firm;
    formData.append('category', new Blob([JSON.stringify(localCategories[0])], { type: "application/json" }));

    // Append image file if it exists
    if (file) {
      formData.append('file', file);
    }

    try {
      let categoryData;
      if (categoryToUpdate) {
        const response = await axios.put(`${baseUrl}/categories/${categoryToUpdate.id}`, formData);
        categoryData = response.data;
   
        // Update the categoryData state with the updated category
        onCategoryUpdate({
          name: categoryData.name,
          imageURL: categoryData.thumbnail // Assume imageURL is part of your API response
        });
        setCategoryData(prevCategories => {
          return prevCategories.map(category => {
            if (category.id === categoryData.id) {
              return categoryData;
            } else {
              return category;
            }
          });
        });
    

        setActiveTab && setActiveTab(categoryData.name);
      } else {
        
        const response = await axios.post(`${baseUrl}/categories`, formData);

        categoryData = response.data;
     
        const newCategory = {
          value: categoryData.id,
          text: categoryData.name
        };

        // Add the new category to the existing selectCategories state
        setSelectCategories && setSelectCategories(prevCategories => [newCategory, ...prevCategories]);
        setSelectCategories && setAlertColor("success");
        setSelectCategories && setShowAlert(true)
        setSelectCategories && setAlertMessage(
          <>Category <strong>{newCategory.text}</strong> has been created, now you should be able to select it in the dropdown</>
        );

        // Add the new categoryData to the state
        //setCategoryData && setCategoryData(prevCategories => [...prevCategories, categoryData]);
       // setCategoryData && setCategoryData(prevCategories => [...(prevCategories || []), categoryData]);
        setCategoryData(prevCategories => [...(prevCategories || []), categoryData]);
        // Update the domains state
        // onDomainsUpdate && onDomainsUpdate(categoryData, true);

        setActiveTab && setActiveTab(categoryData.name);
      }

      // Reset form fields and state
      setName('');
      setDescription('');
      setFile(null);
      setShowCategoryModal && setShowCategoryModal(false);
      setIsCategoryFormSubmitted && setIsCategoryFormSubmitted(true);
    } catch (error) {
      console.error(error);
      if (error.response.status === 409) {
        setAlertColor("danger");
        setAlertMessage("Duplicate category found");
        setShowAlert(true);
      } else {
        setAlertColor("danger");
        setAlertMessage("There is some problem in the Application");
        setShowAlert(true);
      }
    }
  };


  const handleInputChange = (event, index) => {
    const { name, value } = event.target;
    const list = [...localCategories];
    list[index][name] = value;
    setLocalCategories(list);
    checkFormValidity();
  };

  const handleSelectChange = (index, selected) => {
    const list = [...localCategories];
    const selectedDomains = Array.isArray(selected) ? selected : [selected];
    //list[index]['domainIds'] = selectedDomains.map(domain => domain.value);
    list[index]['domainIds'] =selected;

    setLocalCategories(list);
    checkFormValidity();
  };
  
  const checkFormValidity = useCallback(() => {
    const isFormValid = localCategories.every((category) => {
      const { name, domainIds, description } = category; // Note: use domainIds here
  
      // Make sure name, domains, and description are all present
      return name && domainIds && domainIds.length > 0 && description;
    });
    setIsFormValid(isFormValid);
  },[localCategories]);
  

  const handleFileChange = (event) => {
    if (event && event.length > 0) {
      let selectedFile = event[0];
      setFile(selectedFile);
    } else {
      setFile(null); // If no file selected, reset file state to null
    }
    checkFormValidity();
  };

  useEffect(() => {
    checkFormValidity();
  }, [checkFormValidity, localCategories]);




  // Additional state variables as necessary...


  return (
    <section className="grainy-gradient-intro" style={{ marginBottom: '20px' }}>
      <h5 className="display-8 fw-bold text-uppercase text-black mb-0 text-center" style={{ letterSpacing: '15px' }}> Categories </h5>
      <hr className="hr" />
      <MDBCard className="mb-4">
        <MDBCardHeader className="d-flex justify-content-center ">
          <MDBFileUpload className="mb-2 mt-2 justify-content-sm-around text-center" defaultMessage='' onChange={handleFileChange} />
        </MDBCardHeader>

        <MDBCardBody className="text-center pt-4">
          <form onSubmit={handleFormSubmit}>
            {localCategories?.map((category, index) => (
              <div key={index}>

                <MDBInput className="mb-4" label="Name *" name="name" value={category.name} onChange={(e) => handleInputChange(e, index)} required />
                <MDBInput className="mb-4" label="Firm *" name="firm" value={firm} onChange={(e) => handleInputChange(e, index)} required disabled />
                <Dropdown label="Domain *" name="domain" dataForDropDown={selectDomains} onValueChange={(selected) => handleSelectChange(index, selected)} />
                <MDBTextArea rows={2} className="mb-4" label="Description" name="description" value={category.description} onChange={(e) => handleInputChange(e, index)} style={{ marginTop: '20px' }} />

                {index < localCategories.length - 1 && <hr className="hr" />}
              </div>
            ))}
            <div className='d-grid gap-2 d-md-block container text-center' style={{ marginTop: '20px' }}>
             
              <MDBBtn type="submit" disabled={!isFormValid}>
                Save
              </MDBBtn>
            </div>
          </form>
          {showCategoryModal && <div className='d-flex'>
            <MDBBtn className='ms-auto' size='sm' color='dark' style={{ marginTop: '20px' }} onClick={() => setShowCategoryModal(false)}>x</MDBBtn>
          </div>}
        </MDBCardBody>


      </MDBCard>

 
      <MDBAlert open={showAlert}
        color={alertColor}
        position="top-right"
        autohide
        delay={5000}
        appendToBody
        onClose={() => setShowAlert(false)}
      >
        {alertMessage}<MDBBtn color='none' tag='a' onClick={() => setShowAlert(false)}><i className="fas fa-times-circle me-3"></i></MDBBtn>
      </MDBAlert>


    </section>
  );
};


CategoryForm.propTypes = {
  setCategoryData: PropTypes.func,
  categoryData: PropTypes.object,
  setShowCategoryModal: PropTypes.func,
  showCategoryModal: PropTypes.bool,
  categoryToUpdate: PropTypes.object,
  setActiveTab: PropTypes.func

}
export default CategoryForm;
